module.exports = __webpack_public_path__ + "static/media/up.78658c59.png";